export default __webpack_public_path__ + "static/media/3.4ac26a8f.jpg";